import URI from 'urijs';
import { AppRouteID } from '~/app-routes';
import { CommonURLParam } from '~/constants';

export class RedirectUtils {
	/**
	 * Parse a `redirectFrom` parameter from the document location and return the URL to which we are redirecting
	 */
	public static getRedirectUrl(): string {
		let url =
			document.location.href.split(
				`${CommonURLParam.REDIRECT_FROM}=`,
			)[1] || '';
		url = URI.decode(url);

		if (!url.startsWith('#')) {
			url = '';
		} else {
			url = url.split('#/')[1] || '';
		}

		if (url.isBlank()) {
			url = window.location.origin;
		} else {
			url = window.location.origin + '/#/' + url;
		}

		return url;
	}

	public static hasSsoParamEnabled(): boolean {
		const params: URLSearchParams = new URLSearchParams(
			window.location.hash.split('?')[1],
		);
		return params.get(CommonURLParam.SSO) === 'true';
	}

	/**
	 * Encodes the relative URI from a URL location and transforms the path into an encoded
	 * value for a `redirectFrom` parameter that can be later parsed to perform a redirect.
	 * Returns only the relative encoded URI.
	 */
	public static getEncodedUriWithRedirectFrom(redirectUrl: string): string {
		const relativeURI = URI(redirectUrl)
			.relativeTo(window.location.origin)
			.toString();
		const encodedURI = relativeURI.startsWith('#/error')
			? ''
			: URI.encode(relativeURI);
		const redirectURI = encodedURI
			? `${AppRouteID.Login}?${CommonURLParam.REDIRECT_FROM}=${encodedURI}`
			: AppRouteID.Login;
		return redirectURI;
	}

	/**
	 * Encodes the relative URI from a URL location and transforms the path into an encoded
	 * value for a `redirectFrom` parameter that can be later parsed to perform a redirect.
	 * Returns the relative encoded URI as a full absolute URL.
	 */
	public static getEncodedUrlWithRedirectFrom(redirectUrl: string): string {
		return (
			window.location.origin +
			'/#/' +
			this.getEncodedUriWithRedirectFrom(redirectUrl)
		);
	}
}
